module.exports = __webpack_public_path__ + "img/dosing-top.967aea47.png";